import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'paymentType',
    standalone: false
})
export class PaymentTypePipe implements PipeTransform {

  transform(value?: number): string {
    switch (value) {
      case 1:
        return 'Картой';
      case 2:
        return 'Онлайн';
      case 3:
        return 'Наличными';
    }

    return '';
  }

}
